import gql from 'graphql-tag';
import get from 'lodash/get';
import { useQuery } from '@apollo/react-hooks';

const WORK_TYPE = 'Work';
const WORK_FRAGMENT_NAME = 'WorkFieldsForFavorites';
const WORK_FRAGMENT = gql`
  fragment ${WORK_FRAGMENT_NAME} on ${WORK_TYPE} {
    workId
  }
`;

const INVENTORY_ITEM_TYPE = 'ihs_InventoryItemsItem';
const INVENTORY_ITEM_FRAGMENT_NAME = 'InventoryItemFieldsForFavorites';
const INVENTORY_ITEM_FRAGMENT = gql`
  fragment ${INVENTORY_ITEM_FRAGMENT_NAME} on ${INVENTORY_ITEM_TYPE} {
    id
  }
`;

export const fragments = [
  {
    type: WORK_TYPE,
    name: WORK_FRAGMENT_NAME,
    fragment: WORK_FRAGMENT
  },
  {
    type: INVENTORY_ITEM_TYPE,
    name: INVENTORY_ITEM_FRAGMENT_NAME,
    fragment: INVENTORY_ITEM_FRAGMENT
  }
];

const isInventoryItem = ({ __typename }) => __typename === INVENTORY_ITEM_TYPE;
const isWork = ({ __typename }) => __typename === WORK_TYPE;

const favoritesInputFromItems = items =>
  Array.isArray(items)
    ? {
        inventoryItemIds: items.filter(isInventoryItem).map(({ id }) => id),
        workIds: items.filter(isWork).map(({ workId }) => workId)
      }
    : {};

export const ARE_FAVORITED_QUERY = gql`
  query withAreFavorited($favorites: lists_FavoritesInput!) {
    lists_areFavorited(favorites: $favorites) {
      __typename
      id
      isFavorited
      item {
        __typename
        id
        ... on lists_InventoryItemFavorite {
          inventoryItemId
        }
        ... on lists_WorkFavorite {
          workId
        }
      }
    }
  }
`;

export const useFavoriteStatuses = ({ items, isLoggedIn }) => {
  const { data, loading, error } = useQuery(ARE_FAVORITED_QUERY, {
    variables: { favorites: favoritesInputFromItems(items) },
    skip: !isLoggedIn || !Array.isArray(items) || !items.length,
    ssr: false
  });

  const favoriteStatuses = get(data, 'lists_areFavorited', []);

  return {
    loading,
    error,
    favoriteStatuses,
    isFavorited: ({ __typename, workId, id }) => {
      const status = favoriteStatuses.find(({ item }) => {
        switch (__typename) {
          case WORK_TYPE:
            return item.workId === workId;
          case INVENTORY_ITEM_TYPE:
            return item.inventoryItemId === id;
          default:
            return false;
        }
      });

      return [get(status, 'isFavorited', false), status];
    }
  };
};

export default useFavoriteStatuses;
